import './ARJack.css';
import { useState } from "react";
import './Header.css';
// import NoiseEffect from '../components/NoiseEffect';

import logoBosoTokyoWebp from '../img/logo-boso-tokyo.webp';
import logoBosoTokyo from '../img/logo-boso-tokyo.png';
import logoOpenseaWebp from '../img/logo-opensea.webp';
import logoOpensea from '../img/logo-opensea.png';
import logoDiscordWebp from '../img/logo-discord.webp';
import logoDiscord from '../img/logo-discord.png';
import logoTwitterWebp from '../img/logo-twitter.webp';
import logoTwitter from '../img/logo-twitter.png';
import menuIconOpen from '../img/icons/menu-icon-open.svg';
import menuIconClose from '../img/icons/menu-icon-close.svg';

import { Link } from "react-router-dom";

import HeroImg from '../img/ARJack/ARJack-hero.webp';
import HeroTextImg from '../img/ARJack/ARJack-heroText.webp';
import HeroTitleImg from '../img/ARJack/ARJack-heroTitle.webp';
import AppStore from '../img/ARJack/ARJack-AppStore.webp';
import GooglePlay from '../img/ARJack/ARJack-GooglePlay.webp';
import Date from '../img/ARJack/ARJack-date.webp';
import Map from '../img/ARJack/ARJack-map.webp';

import icon01 from '../img/ARJack/icons/01.webp';
import icon02 from '../img/ARJack/icons/02.webp';
import icon03 from '../img/ARJack/icons/03.webp';
import icon04 from '../img/ARJack/icons/04.webp';
import icon05 from '../img/ARJack/icons/05.webp';
import icon06 from '../img/ARJack/icons/06.webp';
import icon07 from '../img/ARJack/icons/07.webp';
import icon08 from '../img/ARJack/icons/08.webp';
import icon09 from '../img/ARJack/icons/09.webp';
import icon10 from '../img/ARJack/icons/10.webp';
import icon11 from '../img/ARJack/icons/11.webp';
import icon12 from '../img/ARJack/icons/12.webp';
import icon13 from '../img/ARJack/icons/13.webp';
import icon14 from '../img/ARJack/icons/14.webp';
import icon15 from '../img/ARJack/icons/15.webp';

import icon17 from '../img/ARJack/icons/17.webp';
import icon18 from '../img/ARJack/icons/18.webp';
import icon19 from '../img/ARJack/icons/19.webp';
import icon20 from '../img/ARJack/icons/20.webp';
import icon21 from '../img/ARJack/icons/21.webp';
import icon22 from '../img/ARJack/icons/22.webp';
import icon23 from '../img/ARJack/icons/23.webp';
import icon24 from '../img/ARJack/icons/24.webp';
import icon25 from '../img/ARJack/icons/25.webp';

import partnersipImg from '../img/ARJack/ARJack-partnersipImg.webp';
import bosotokyoIcon from '../img/ARJack/bosotokyo.webp';
import MADworld from '../img/ARJack/MADworld.webp';

import FollowUs from '../components/FollowUs';
import Footer from './Footer';
import ScrollItem from './ScrollItem';

export default function ARJack() {
    const Header = () => {
        const [isModalOpen, setIsModalOpen] = useState(false);

        const Menu = () => {
            return (
                <div className="Header__menu">
                    <div className="Header__logo glitchPatternInfinite05">
                        <Link to="/">
                            <picture>
                                <source type="image/webp" srcSet={logoBosoTokyoWebp} />
                                <img src={logoBosoTokyo} alt="BoSo TOKYO ロゴ" />
                            </picture>
                        </Link>
                    </div>
                    <div className="Header__rightContainer">
                        <nav className="Header__nav">
                            <ul>
                                <li><a href="#About">About</a></li>
                                <li><a href="#Contents">Contents</a></li>
                                <li><a href="#Prize">Prize</a></li>
                                <li><a href="#Partnership">Partnership</a></li>
                            </ul>
                        </nav>

                        <div className="Header__icon">
                            <a href="https://opensea.io/collection/bosotokyo-official" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoOpenseaWebp} />
                                    <img src={logoOpensea} alt="OpenSea link" />
                                </picture>
                            </a>
                        </div>
                        <div className="Header__icon glitchPatternInfinite03">
                            <a href="https://discord.gg/bosotokyo" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoDiscordWebp} />
                                    <img src={logoDiscord} alt="Discord link" />
                                </picture>
                            </a>
                        </div>
                        <div className="Header__icon glitchPatternInfinite04">
                            <a href="https://twitter.com/BosoTokyo" target="_blank">
                                <picture>
                                    <source type="image/webp" srcSet={logoTwitterWebp} />
                                    <img src={logoTwitter} alt="Twitter link" />
                                </picture>
                            </a>
                        </div>

                        <div className="Header__menuBtn">
                            <button onClick={() => setIsModalOpen(!isModalOpen)}><img src={isModalOpen ? menuIconClose : menuIconOpen} alt="sp menu open" /></button>
                        </div>

                    </div>
                </div>
            )
        }

        return (

            <>
                {isModalOpen ? (
                    <header className="Header open" id="HeaderLogo">
                        <Menu />
                        <div className="Header__Modal">
                            <Menu />
                            <nav className="Header__nav--sp">
                                <ul>
                                    {/* <li><Link to="/gallery" onClick={() => setIsModalOpen(false)}>Gallery</Link></li>
                                    <li><Link to="/revving" onClick={() => setIsModalOpen(false)}>Revving</Link></li>
                                    <li><a href="#about" onClick={() => setIsModalOpen(!isModalOpen)}>About</a></li> */}

                                    <li><a href="#About">About</a></li>
                                    <li><a href="#Contents">Contents</a></li>
                                    <li><a href="#Prize">Prize</a></li>
                                    <li><a href="#Partnership">Partnership</a></li>
                                </ul>
                            </nav>
                        </div>
                    </header>

                ) : (
                    <header className="Header" id="HeaderLogo">
                        <Menu />
                    </header>
                )}
            </>

        );
    }

    const AboutItem = ({ children, title }) => {
        return (
            <div className="ARJack__about__item">
                <h3 className="ARJack__about__item__h3">{title}</h3>
                <div className="ARJack__about__item__content">
                    {children}
                </div>
            </div>
        )
    }

    const GridItem = (props) => {
        return (
            <div className="ARJack__GridItem">
                <div className="ARJack__GridItem__img">
                    <img src={props.img} alt={props.alt} />
                </div>
                <p className="ARJack__GridItem__name">{props.name}</p>
                <p className="ARJack__GridItem__prize">{props.prize}</p>
            </div>
        )
    }

    return (
        <>
            {/* <NoiseEffect /> */}
            <Header />
            <div className="ARJack">

                <div className="ARJack__heroImg">
                    <img className="ARJack__heroMainImg" src={HeroImg} alt="渋谷スクランブル交差点を街ごとジャック！！QFRONTが巨大スロットマシーンにかわる前代未聞の都市型XRエンターテイメント" />
                    <img className="ARJack__heroTextImg" src={HeroTextImg} alt="渋谷スクランブル交差点を街ごとジャック！！QFRONTが巨大スロットマシーンにかわる前代未聞の都市型XRエンターテイメント" />
                    <img src={HeroTitleImg} alt="渋谷スクランブル交差点を街ごとジャック！！QFRONTが巨大スロットマシーンにかわる前代未聞の都市型XRエンターテイメント" />
                </div>

                <div className="ARJack__main">
                    <img className="ARJack__dateImg" src={Date} alt="hero img" />

                    <section className="ARJack__about" id="About">
                        <div className="ARJack__sectionTitle">
                            <h2 className="ARJack__h2">About</h2>
                            <div className="ARJack__sectionBorder"></div>
                        </div>

                        <iframe className="ARJack__about__movie" src="https://player.vimeo.com/video/758951801?h=42f85b901a" width="1080" height="608" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>

                        <p className="ARJack__about__description">渋谷スクランブル交差点にスマートフォンをかざすと、
                            BOSO TOKYO × MAD Worldの世界が出現する。

                            渋谷の実空間をXRで拡張し、今までにない
                            都市型XRエンターテイメントを提供する
                            「渋谷スクランブルレイヤー」が10/15よりスタート。

                            第一弾として、BOSO TOKYO × MAD Worldの
                            コラボレーションが実現しました。

                            渋谷の実空間がARでジャックされることに加え、
                            QFRONTは巨大なスロットマシーンに変わり、
                            国内外のNFTプロジェクトと連動した景品が当たる
                            キャンペーンの入り口になります。

                            その他にもインタラクティブな仕掛けを用意していますので
                            ぜひ渋谷スクランブル交差点で体験ください。</p>

                        <div className="ARJack__about__itemContainer">

                            <AboutItem title="日時" >
                                <p className="ARJack__about__item__text"> 10/15(SAT)〜11/18(SUN)
                                    ※10/31のみ不開催</p>
                            </AboutItem>

                            <AboutItem title="場所" >
                                <p className="ARJack__about__item__text">
                                    渋谷スクランブル交差点の上に重なる
                                    デジタルレイヤー「渋谷スクランブルレイヤー」
                                </p>
                            </AboutItem>

                            <AboutItem title="体験方法" >
                                <p className="ARJack__about__item__text">本イベントへの参加はSTYLYアプリのダウンロードが必要です。</p>
                                <div className="ARJack__about__item__flex">
                                    <a href="https://apps.apple.com/jp/app/styly/id1477168256" target="_blank"><img src={AppStore} alt="AppStore icon" /></a>
                                    <a href="https://play.google.com/store/apps/details?id=com.psychicvrlab.stylymr&hl=ja&gl=US" target="_blank"><img src={GooglePlay} alt="GooglePlay icon" /></a>
                                </div>

                                <p className="ARJack__about__item__text">STYLYアプリが入ったスマートフォンで
                                    下記ボタンをクリックすることで
                                    「BOSO SCRAMBLE」が起動します。
                                    ハチ公広場方面からスクランブル交差点の
                                    方に向けるとARが出現します。</p>

                                {/* <div className="ARJack__contents__step__link--disable">
                                    <span>2022.10.15 公開！</span>
                                </div> */}
                                {/* <div className="ARJack__about__item__link">
                                    <span href="https://bit.ly/3rOyAR0" target="_blank">BOSO SCRAMBLE</span>
                                </div> */}
                                <div className="ARJack__about__item__link">
                                    <a href="https://bit.ly/3rOyAR0" target="_blank">BOSO SCRAMBLE</a>
                                </div>

                                <div className="ARJack__about__item__img">
                                    <img src={Map} alt="map image" />
                                </div>
                            </AboutItem>

                        </div>
                    </section>

                    <section className="ARJack__contents" id="Contents">
                        <div className="ARJack__sectionTitle">
                            <h2 className="ARJack__h2">Contents</h2>
                            <div className="ARJack__sectionBorder"></div>
                        </div>
                        <h3 className="ARJack__contents__h3">BOSO SLOT</h3>
                        <div className="ARJack__contents__img">
                            <img src={HeroImg} alt="img" />
                        </div>

                        <p className="ARJack__contents__description">体験型コンテンツとして、QFRONTが
                            巨大なスロットマシーンに変わる「BOSO SLOT」を
                            お楽しみいただくことができます。

                            BOSO TOKYOをはじめ、様々な国内外の
                            NFTプロジェクトのNFTやホワイトリストが
                            抽選でもらえるキャンペーンにもなっています。</p>
                        <p className="ARJack__contents__description__sub">※前半（10/15 -10/30）と後半（11/1-11/18）で
                            参加プロジェクトや景品が変わります。</p>

                        <div className="ARJack__contents__stepContainer">
                            <h3 className="ARJack__contents__stepContainer__h3">HOW TO PLAY</h3>

                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-1</h4>
                                <p className="ARJack__contents__step__text">
                                    STYLYアプリが入ったスマートフォンで、
                                    下記のボタンをクリックし、
                                    BOSO SCRAMBLEを起動する。</p>
                                {/* <div className="ARJack__contents__step__link--disable">
                                    <span>2022.10.15 公開！</span>
                                </div> */}
                                {/* <div className="ARJack__contents__step__link">
                                    <span href="https://bit.ly/3rOyAR0" target="_blank">BOSO SCRAMBLE</span>
                                </div> */}
                                <div className="ARJack__contents__step__link">
                                    <a href="https://bit.ly/3rOyAR0" target="_blank">BOSO SCRAMBLE</a>
                                </div>
                            </div>

                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-2</h4>
                                <p className="ARJack__contents__step__text">
                                    渋谷スクランブル交差点のQFRONTビルの方に
                                    カメラを向けるとBOSO SLOTが出現します。<br />®
                                    <span className="ARJack__contents__step__text__sub">※ハチ公前広場からなど一定の距離をとってください</span></p>
                                <div className="ARJack__contents__step__img">
                                    <img src={Map} alt="map image" />
                                </div>
                            </div>

                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-3</h4>
                                <p className="ARJack__contents__step__text">
                                    「SLOT START」をタップすることでプレイできます。
                                    絵柄が揃った場合は、揃った絵柄のプロジェクトの
                                    賞品に応募する権利が獲得できます。</p>
                            </div>

                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-4</h4>
                                <p className="ARJack__contents__step__text">絵柄が揃った場合は、スクリーンショットを取り、
                                    その後に表示される応募ページの手順に従い、
                                    30分以内にTwitterに投稿することで
                                    応募が完了します。
                                    絵柄が揃わなかった場合も、参加賞として
                                    オリジナルの待ち受け画像などがもらえます。</p>
                            </div>

                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-5</h4>
                                <p className="ARJack__contents__step__text">
                                    Twitter上で、条件達成者の中から抽選を行い、
                                    当選者のみにTwitterからDMでご連絡させて
                                    いただきます。<br />
                                    <span className="ARJack__contents__step__text__sub"> ※当選連絡は、前半は11/1以降、後半は11/19以降を
                                        予定しています</span>
                                </p>
                            </div>
                        </div>


                        <h3 className="ARJack__contents__caution">CAUTION</h3>
                        <ul className="ARJack__contents__caution__ul">
                            <li>本イベントへ参加する際は交通ルールを守り、他の人や車の通行の妨げにならないようご注意ください。</li>
                            <li>本イベントへ参加中のトラブルなどに関しましては一切の責任を負いません。</li>
                            <li>キャンペーン当選連絡に対して3日以上返答がない場合は当選取り消しとさせていただきます。</li>
                            <li>スロット画面を加工する、他人の撮ったキャプチャをアップするなど、不正な手段でキャンペーン応募を行った場合は、当選対象から外させていただきます。当選後に不正が発覚した場合は、当選連絡後でも当選取り消しとさせていただきます。</li>
                            <li>スクリーンショットを撮影する際、なるべく通行人が映らないよう画角を上に向けての撮影をお願いいたします。</li>
                            <li>ツイートされたスクリーンショットにより発生するトラブルについて一切の責任を負いません。</li>
                        </ul>
                    </section>

                    <section className="ARJack__prize" id="Prize">
                        <div className="ARJack__sectionTitle">
                            <h2 className="ARJack__h2">Prize</h2>
                            <div className="ARJack__sectionBorder"></div>
                        </div>
                        <span className="ARJack__h2__span">2022.10.15-2022.10.30</span>

                        <div className="ARJack__prize__grid">
                            <GridItem img={icon01} alt="icon" name="BOSO TOKYO" prize="1 NFT FREE MINT" />
                            <GridItem img={icon02} alt="icon" name="BOSO TOKYO" prize="30 PHYSICAL GOODS" />
                            <GridItem img={icon03} alt="icon" name="MADWORLD" prize="100 MYSTERY BOXES NFTS DROPPING" />
                            <GridItem img={icon15} alt="icon" name="MADMIND" prize="1 NFT FREE MINT" />
                            <GridItem img={icon04} alt="icon" name="GENSO" prize="RARE ITEM 20 NFT FREE MINT" />
                            <GridItem img={icon05} alt="icon" name="ISEKAI META" prize="1 NFT FREE MINT" />
                            <GridItem img={icon06} alt="icon" name="OLDEUS" prize="10 NFT WHITE LIST" />
                            <GridItem img={icon07} alt="icon" name="MITAMA" prize="3 NFT FREE MINT" />
                            <GridItem img={icon10} alt="icon" name="MACHINA" prize="1 NFT FREE MINT" />
                            <GridItem img={icon08} alt="icon" name="DUDU" prize="10 NFT WHITE LIST" />
                            <GridItem img={icon09} alt="icon" name="DYDX HEDGIES" prize="1 NFT FREE MINT" />
                            <GridItem img={icon11} alt="icon" name="CRYPTOSIMEJI" prize="5 NFT FREE MINT" />
                            <GridItem img={icon12} alt="icon" name="KUMALEON" prize="1 NFT FREE MINT" />
                            <GridItem img={icon13} alt="icon" name="NANNDA" prize="3 NFT FREE MINT" />
                        </div>


                        <span className="ARJack__h2__span ARJack__h2__span--mt">2022.11.1-2022.11.18</span>
                        <div className="ARJack__prize__grid">
                            <GridItem img={icon01} alt="icon" name="BOSO TOKYO" prize="1 NFT Free Mint" />
                            <GridItem img={icon17} alt="icon" name="BOSO TOKYO" prize="30 PHYSICAL GOODS" />
                            <GridItem img={icon18} alt="icon" name="MADWORLD" prize="2 NFT Free Mint" />
                            <GridItem img={icon19} alt="icon" name="DFT" prize="1 NFT Free Mint" />
                            <div className="ARJack__GridItem">
                                <div className="ARJack__GridItem__img">
                                    <img src={icon20} alt="icon" />
                                </div>
                                <p className="ARJack__GridItem__name">AZITO</p>
                                <p className="ARJack__GridItem__prize ARJack__GridItem__prize--min">1 NFT Free Mint or 1 AZITO Hoodie or 3 AZITO Sticker</p>
                            </div>
                            {/* <GridItem img={icon20} alt="icon" name="AZITO" prize="1 NFT Free Mint or 1 AZITO Hoodie or 3 AZITO Sticker" /> */}
                            <GridItem img={icon21} alt="icon" name="GASHO 2.0" prize="XS size 2.5D art" />
                            <GridItem img={icon22} alt="icon" name="Project Zenogakki" prize="1 NFT Free Mint" />
                            <GridItem img={icon23} alt="icon" name="Owange NFT" prize="10 NFT Whitelist" />
                            <div className="ARJack__GridItem">
                                <div className="ARJack__GridItem__img">
                                    <img src={icon24} alt="icon" />
                                </div>
                                <p className="ARJack__GridItem__name">MACHINA</p>
                                <p className="ARJack__GridItem__prize ARJack__GridItem__prize--min">1 NFT Free Mint or Whitelist*Depends on the time of MACHINA NFT sale</p>
                            </div>
                            <GridItem img={icon25} alt="icon" name="HOSHI BOSHI" prize="5 NFT Whitelist" />
                        </div>

                        {/* <p className="ARJack__prize__andMore">AND MORE</p> */}

                        <p className="ARJack__prize__sub">※画像はイメージです。実際にもらえるNFTの絵柄とは異なる場合があります。あらかじめ、ご了承ください。</p>

                        {/* <div className="ARJack__prize__commingsoon">
                            <p className="ARJack__prize__commingsoon__title">
                                2022.11.1-11.13<br />
                                Coming Soon</p>
                            <p className="ARJack__prize__commingsoon__text">さらに隠し要素や
                                新コンテンツも準備中！
                                乞うご期待！</p>
                        </div> */}
                    </section>

                    {/* Partnership */}
                    <section className="ARJack__Partnership" id="Partnership">
                        <div className="ARJack__sectionTitle">
                            <h2 className="ARJack__h2__Partnership">Partnership</h2>
                            <div className="ARJack__sectionBorder"></div>
                        </div>
                        <div className="ARJack__Partnership__img">
                            <img src={partnersipImg} alt="img" />
                        </div>

                        <p className="ARJack__Partnership__description">
                            メタバース時代のアイデンティティブランドをビジョンに掲げるBOSO TOKYOはアニモカグループのMADworldと提携しました。今後はアニモカブランズやMADworldの持っている世界規模での企業、クリエイター、IPなどを活かしてBOSO TOKYOのロードマップを力強く推し進めていきます。</p>

                        <div className="ARJack__Partnership__partnerContainer">
                            <div className="ARJack__Partnership__partner">
                                <div className="ARJack__Partnership__partner__img">
                                    <img src={bosotokyoIcon} alt="img" />
                                </div>
                                <div className="ARJack__Partnership__partner__rightContainer">
                                    <p className="ARJack__Partnership__partner__description">
                                        BŌSŌ TOKYO -暴走東京- は、日本を代表するイラストレーター「天神英貴」が、暴走族カルチャー×サイバーSFの世界観で描く、メタバース時代のアイデンティティブランドをつくるプロジェクトです。ユーティリティーとして、唯一無二のアートワーク、そして、PFPに留まらず、クオリティの高い3Dデータの配布やメタバース空間に持ち込めるアバターを用意します。さらに商用利用権の提供や、専用のコミュニティやイベントへのアクセスが可能になります。
                                    </p>
                                    <div className="ARJack__Partnership__partner__linkCnotainer">
                                        <a className="ARJack__Partnership__partner__link" href="https://www.bosotokyo.com/" target="_blank">Web Site</a>
                                        <a className="ARJack__Partnership__partner__link" href="https://opensea.io/ja/collection/bosotokyo-official" target="_blank">OpenSea</a>
                                    </div>
                                </div>
                            </div>

                            <div className="ARJack__Partnership__partner">
                                <div className="ARJack__Partnership__partner__img">
                                    <img src={MADworld} alt="img" />
                                </div>
                                <div className="ARJack__Partnership__partner__rightContainer">
                                    <p className="ARJack__Partnership__partner__description">
                                        MADworldは香港のAnimoca BrandsとUCOLLEX INTERNATIONALとの合弁会社で、代表のRobert TranはAnimoca Brands株式会社の共同創業者であり、取締役を務めています。
                                        NFT.NYCではUCOLLEX、MADworld、Animoca Brands KK、講談社が共同で「GHOST IN THE SHELL / 攻殻機動隊」、「FAIRY TAIL」を世界に配信した。自社でもPopeye、Abathing ApeなどのNFTプロジェクトを抱えている。
                                    </p>
                                    <div className="ARJack__Partnership__partner__linkCnotainer">
                                        <a className="ARJack__Partnership__partner__link" href="https://madworld.io/" target="_blank">Web Site</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>


                <FollowUs />

                <p className="ARJack__footerText">※AppleとAppleのロゴは米国および他の国々で登録されたApple Inc.の商標です。App Storeは、Apple Inc.のサービスマークです。
                    ※Google Play および Google Play ロゴは、Google LLC の商標です。</p>

            </div>
            <Footer />
        </>
    );
}